/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  gl: {
    nested: {
      JDCreateTunnelReq: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          callee: {
            type: "string",
            id: 2
          },
          authToken: {
            type: "string",
            id: 3
          },
          accessToken: {
            type: "string",
            id: 4
          }
        }
      },
      JDCreateTunnelResp: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          errcode: {
            type: "sint32",
            id: 2
          },
          callee: {
            type: "string",
            id: 3
          },
          status: {
            type: "sint32",
            id: 4
          },
          callerPid: {
            type: "sint32",
            id: 5
          }
        }
      },
      JDDestroyTunnelReq: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          callee: {
            type: "string",
            id: 2
          },
          authToken: {
            type: "string",
            id: 3
          },
          accessToken: {
            type: "string",
            id: 4
          }
        }
      },
      JDDestroyTunnelResp: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          errcode: {
            type: "sint32",
            id: 2
          },
          callee: {
            type: "string",
            id: 3
          }
        }
      },
      JDStartMapSrvReq: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          callee: {
            type: "string",
            id: 2
          },
          svFwdIP: {
            type: "string",
            id: 3
          },
          svFwdPort: {
            type: "sint32",
            id: 4
          },
          authToken: {
            type: "string",
            id: 5
          },
          accessToken: {
            type: "string",
            id: 6
          },
          listenIP: {
            type: "string",
            id: 7
          },
          listenPort: {
            type: "sint32",
            id: 8
          },
          speedLimit: {
            type: "sint32",
            id: 9
          },
          rule: {
            type: "sint32",
            id: 10
          }
        }
      },
      JDStartMapSrvResp: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          errcode: {
            type: "sint32",
            id: 2
          },
          callee: {
            type: "string",
            id: 3
          },
          svMapPort: {
            type: "sint32",
            id: 4
          },
          callerPid: {
            type: "sint32",
            id: 5
          },
          svMapHost: {
            type: "string",
            id: 6
          }
        }
      },
      JDStopMapSrvReq: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          callee: {
            type: "string",
            id: 2
          },
          svFwdIP: {
            type: "string",
            id: 3
          },
          svFwdPort: {
            type: "sint32",
            id: 4
          },
          svMapPort: {
            type: "sint32",
            id: 5
          },
          authToken: {
            type: "string",
            id: 6
          },
          accessToken: {
            type: "string",
            id: 7
          }
        }
      },
      JDStopMapSrvResp: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          errcode: {
            type: "sint32",
            id: 2
          },
          callee: {
            type: "string",
            id: 3
          }
        }
      },
      JDSpeedLimitReq: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          callee: {
            type: "string",
            id: 2
          },
          speedLimit: {
            type: "sint32",
            id: 3
          },
          authToken: {
            type: "string",
            id: 4
          },
          accessToken: {
            type: "string",
            id: 5
          }
        }
      },
      JDSpeedLimitResp: {
        fields: {
          sequenceID: {
            type: "uint64",
            id: 1
          },
          errcode: {
            type: "sint32",
            id: 2
          },
          callee: {
            type: "string",
            id: 3
          }
        }
      }
    }
  }
});

module.exports = $root;
